/**
 * DirectTalk (API)
 *  ダイレクトトーク関連のAPI
 */
import session from './session'
import file from './file'
import stream from './stream'

var uri = process.env.API_ENDPOINT

export default {
  // seeker 系あとでリファクタ必須
  createSeekerData(data) {
    return session.post(uri + '/api/dt/create/', data)
  },
  createSeekerHistoryData(data) {
    return session.post(uri + '/api/dt/h_create/', data)
  },
  createSeekerActionHistoryData(data) {
    return session.post(uri + '/api/dt/a_h_create/', data)
  },
  setSeekerData(data) {
    return session.put(uri + '/api/dt/set/', data)
  },
  getSeekerData(id) {
    return session.get(uri + '/api/dt/get/' + id + '/')
  },
  getSubscribedSeekers(conditions){
    return session.post(uri + '/api/dt/get_subscribed_seekers/', conditions)
  },
  getSeekerFilterItems(conditions) {
    return session.post(uri + '/api/dt/seeker_filter_item/', conditions)
  },
  searchSeeker(searchInfo) {
    return session.get(
      uri + '/api/dt/seeker_search/' + searchInfo.name + '/' + searchInfo.email + '/'
    )
  },
  getMessageData(id, cid, type, pages) {
    return session.get(
      uri + '/api/dt/getmessage/' + id + '/' + cid + '/' + type + '/' + pages + '/'
    )
  },
  importMessageData(data) {
    return session.post(uri + '/api/dt/impmessage/', data)
  },
  getRoomData(id, cid, data) {
    if (!data) data = {}
    return session.post(uri + '/api/dt/getroom/' + id + '/' + cid + '/', data)
  },
  getRoomTempData(cid) {
    return session.get(uri + '/api/dt/getroomtemp/' + cid + '/')
  },
  getRoomDemoData(cid) {
    return session.get(uri + '/api/dt/getroom_demo/' + cid + '/')
  },
  getRoomListData(data) {
    return session.post(uri + '/api/dt/getroom/list/', data)
  },
  getRoboInfo(data) {
    return session.post(uri + '/api/dt/get_robo_info/', data)
  },
  setIsRead(id, cid, speaker) {
    return session.get(uri + '/api/dt/setisread/' + id + '/' + cid + '/' + speaker + '/')
  },
  addCount(id, cid, sid, data) {
    return session.post(uri + '/api/dt/add_count/' + id + '/' + cid + '/' + sid + '/', data)
  },
  getUrlList(data) {
    return session.post(uri + '/api/dt/geturllist/', data)
  },
  seekerCount(type) {
    return session.get(uri + '/api/dt/seeker_count?' + type)
  },
  setStar(data) {
    return session.put(uri + '/api/dt/set_star/', data)
  },
  getGraphData(minDay, maxDay) {
    return session.get(uri + '/api/dt/graphData/' + minDay + '/' + maxDay + '/')
  },
  // 履歴書
  createResume(data) {
    return session.post(uri + '/api/dt/create_resume/', data)
  },
  createResumeAndSeeker(data) {
    return session.post(uri + '/api/dt/create_resume_seeker/', data)
  },
  updateResume(data) {
    return session.patch(uri + '/api/dt/update_resume/', data)
  },
  createResumeDemo(data) {
    return session.post(uri + '/api/dt/create_resume_demo/', data)
  },
  getReadCount(cid) {
    return session.get(uri + '/api/dt/get_read_count/' + cid + '/')
  },
  csvExport(data) {
    return session.post(uri + '/api/dt/export_seeker/', data)
  },
  checkCsvExport(job_id) {
    return session.get(uri + '/api/dt/export_seeker/' + job_id)
  },
  parseSeekerCSV(data) {
    return session.post(uri + '/api/dt/parse_seeker_csv/', data)
  },
  // 応募者エクスポートテンプレート
  createSeekerExportTemplate(data) {
    return session.post(uri + '/api/dt/seeker_export_template/', data)
  },
  getSeekerExportTemplate() {
    return session.get(uri + '/api/dt/seeker_export_template/')
  },
  updateSeekerExportTemplate(id, data) {
    return session.patch(uri + '/api/dt/seeker_export_template/' + id, data)
  },
  deleteSeekerExportTemplate(id) {
    return session.delete(uri + '/api/dt/seeker_export_template/' + id)
  },
  setManage(data) {
    return session.post(uri + '/api/dt/set_manage/', data)
  },
  getLastMessageData(id, cid, type, pages) {
    return session.get(
      uri + '/api/dt/getlastmessage/' + id + '/' + cid + '/' + type + '/' + pages + '/'
    )
  },
  getLastMessageReadData(id, cid, type, pages) {
    return session.get(
      uri + '/api/dt/getlastreadmessage/' + id + '/' + cid + '/' + type + '/' + pages + '/'
    )
  },
  makeDialogCSV(data) {
    return session.post(uri + '/api/dt/make_dialog_csv/', data)
  },
  checkMakeDialogCSV(job_id) {
    return session.get(uri + '/api/dt/make_dialog_csv/' + job_id)
  },
  uploadOCR(data) {
    return session.post(uri + '/api/dt/upload_ocr/', data)
  },
  // Emailからのアクセスの時の応募者のデータ取得API
  getFromEmailSeeker(data) {
    return session.get(uri + '/api/dt/get_from_email_seeker/' + data.company_hash + '/' + data.id)
  },
  // 再構築したSeeker系のCRUD
  createSeeker(data) {
    return session.post(uri + '/api/dt/seeker/', data)
  },
  importSeeker(data) {
    return session.post(uri + '/api/dt/import_seeker/', data)
  },
  getSeeker(id) {
    if (id) return session.get(uri + '/api/dt/seeker/' + id)
    else return session.get(uri + '/api/dt/seeker/')
  },
  filteredSeeker(data) {
    return session.post(uri + '/api/dt/seeker_filter/' + data.id, data)
  },
  updateSeeker(data) {
    return session.patch(uri + '/api/dt/seeker/', data)
  },
  updateSeekerAny(data) {
    return session.patch(uri + '/api/dt/seeker_any/', data)
  },
  deleteSeeker(id) {
    return session.delete(uri + '/api/dt/seeker/' + id)
  },
  outputSeekerPDF(data) {
    return stream.post(uri + '/api/dt/seeker_output_pdf/', data)
  },
  isSeekerSubscribed(pk) {
    return session.get(uri + '/api/dt/is_seeker_subscribed/' + pk)
  },
  // 資格API
  createQualification(data) {
    return session.post(uri + '/api/dt/qualification/', data)
  },
  createQualificationAny(data) {
    return session.post(uri + '/api/dt/qualification_any/', data)
  },
  getQualification(id) {
    if (id) return session.get(uri + '/api/dt/qualification/' + id)
    else return session.get(uri + '/api/dt/qualification/')
  },
  updateQualification(data) {
    return session.patch(uri + '/api/dt/qualification/', data)
  },
  deleteQualification(id) {
    return session.delete(uri + '/api/dt/qualification/' + id)
  },
  deleteResume(seeker_pk) {
    return session.delete(uri + '/api/dt/delete_resume/' + seeker_pk)
  },
  createResumePdf(data) {
    return session.post(uri + '/api/dt/create_resume_pdf/', data)
  },
  // 職歴API
  createCareer(data) {
    return session.post(uri + '/api/dt/career/', data)
  },
  createCareerAny(data) {
    return session.post(uri + '/api/dt/career_any/', data)
  },
  getCareer(id) {
    if (id) return session.get(uri + '/api/dt/career/' + id)
    else return session.get(uri + '/api/dt/career/')
  },
  updateCareer(data) {
    return session.patch(uri + '/api/dt/career/', data)
  },
  deleteCareer(id) {
    return session.delete(uri + '/api/dt/career/' + id)
  },
  // Seeker File API
  createSeekerFiles(data) {
    return file.post(uri + '/api/dt/seekerfiles/', data)
  },
  createSeekerFilesAny(data) {
    return file.post(uri + '/api/dt/seekerfiles_any/', data)
  },
  getSeekerFiles(id) {
    if (id) return session.get(uri + '/api/dt/seekerfiles/' + id)
    else return session.get(uri + '/api/dt/seekerfiles/')
  },
  updateSeekerFiles(data) {
    return file.patch(uri + '/api/dt/seekerfiles/', data)
  },
  deleteSeekerFiles(id) {
    return session.delete(uri + '/api/dt/seekerfiles/' + id)
  },
  // SeekerCustomColumns API
  createSeekerCustomColumns(data) {
    return session.post(uri + '/api/dt/seeker_custom_columns/', data)
  },
  getSeekerCustomColumns(id) {
    if (id) return session.get(uri + '/api/dt/seeker_custom_columns/' + id)
    else return session.get(uri + '/api/dt/seeker_custom_columns/')
  },
  updateSeekerCustomColumns(data) {
    return session.patch(uri + '/api/dt/seeker_custom_columns/', data)
  },
  deleteSeekerCustomColumns(id) {
    return session.delete(uri + '/api/dt/seeker_custom_columns/' + id)
  },
  sendEmailToSeeker(email) {
    return session.post(uri + '/api/dt/send_email_to_seeker/', email)
  },
  sendSMSToSeeker(email) {
    return session.post(uri + '/api/dt/send_sms_to_seeker/', email)
  },
  checkSMSJobStatus(jobId) {
    return session.get(`${uri}/api/dt/sms_job_status/${jobId}/`)
  },  
  getSendedEmailList(id) {
    return session.get(uri + '/api/dt/get_sended_email_list/' + id)
  },
  getSendedSMSList(id) {
    return session.get(uri + '/api/dt/get_sended_sms_list/' + id)
  },
  getEmailList(seeker_id) {
    return session.get(uri + '/api/dt/get_email_list/' + seeker_id)
  },
  getEmailListing() {
    return session.get(uri + '/api/dt/get_email_listing/')
  },
  getSmsListing() {
    return session.get(uri + '/api/dt/get_sms_listing/')
  },
  getActionListing() {
    return session.get(uri + '/api/dt/get_action_listing/')
  },
  sendMessage(sendData) {
    return session.post(uri + '/api/dt/send_message/', sendData)
  },
  getCompanySMSHistory (data) {
    return session.post(uri + '/api/dt/get_company_sms_history/', data)
  },
  getSendedBotEmailList(bot_id) {
    return session.get(uri + '/api/dt/get_sended_bot_email_List/' + bot_id)
  },
  getSendedScenarioEmailList(bot_id) {
    return session.get(uri + '/api/dt/get_sended_scenario_email_list/' + bot_id)
  },
  // ScoutHistory API
  createScoutHistory(data) {
    return session.post(uri + '/api/dt/scout_history/', data)
  },
  createScoutHistoryAny(data) {
    return session.post(uri + '/api/dt/scout_history_any/', data)
  },
  getScoutHistory(id) {
    if (id) return session.get(uri + '/api/dt/scout_history/' + id)
    else return session.get(uri + '/api/dt/scout_history/')
  },
  updateScoutHistory(data) {
    return session.patch(uri + '/api/dt/scout_history/', data)
  },
  updateScoutHistoryAny(data) {
    return session.patch(uri + '/api/dt/scout_history_any/', data)
  },
  deleteScoutHistory(id) {
    return session.delete(uri + '/api/dt/scout_history/' + id)
  },
  // RecruitmentFlowActionHistory API
  createRecruitmentFlowActionHistory(data) {
    return session.post(uri + '/api/dt/recruit_flow_action_history/', data)
  },
  getRecruitmentFlowActionHistory(id) {
    if (id) return session.get(uri + '/api/dt/recruit_flow_action_history/' + id)
    else return session.get(uri + '/api/dt/recruit_flow_action_history/')
  },
  updateRecruitmentFlowActionHistory(data) {
    return session.patch(uri + '/api/dt/recruit_flow_action_history/', data)
  },
  deleteRecruitmentFlowActionHistory(id) {
    return session.delete(uri + '/api/dt/recruit_flow_action_history/' + id)
  },
  // Emailからのアクション
  getEmailAction(data) {
    return session.get(
      uri + '/api/dt/email_action/' + data.id + '/' + data.action + '/' + data.status + '/'
    )
  },
  createFromEmailActionHistory(data) {
    return session.post(uri + '/api/dt/create_from_email_action_history/', data)
  },
  fetchSeekerInputInfo(cb) {
    return session.post(
      uri + '/api/dt/fetch_seeker_input_info/' + cb.bot_id + '/' + cb.name + '/' + cb.scenario_name
    )
  },
  checkFetchSeekerInputInfo(task_id) {
    return session.get(uri + '/api/dt/fetch_seeker_input_info/' + task_id)
  },
  fetchSeekerReply(data) {
    return session.get(uri + '/api/dt/fetch_seeker_reply/' + data.seeker)
  },
  sendSeekerReply(data) {
    return session.post(uri + '/api/dt/send_seeker_reply/', data)
  },
  sendSeekerContact(data) {
    return session.post(uri + '/api/dt/send_seeker_contact/', data)
  },
  fetchSeekerContact(data) {
    return session.get(uri + '/api/dt/fetch_seeker_contact/' + data.seeker)
  },
  // SeekerTagHistory
  createSeekerTagHistory(data) {
    return session.post(uri + '/api/dt/seeker_tag_history/', data)
  },
  // スカウトグラフの取得
  getScoutGraph() {
    return session.get(uri + '/api/dt/scout_graph/')
  },
  // スカウトの一括送付
  setAllScout(data) {
    return session.post(uri + '/api/dt/set_all_scout/', data)
  },
  // 請求用従量課金のデータ取得
  getBiilingData(data) {
    return session.get(uri + '/api/dt/get_billing_data/' + data.year + '/' + data.month)
  },
  createInterviewHistory(interviewHistory) {
    return session.post(uri + '/api/dt/interview_history/', interviewHistory)
  },
  deleteInterviewHistory(data) {
    return session.patch(uri + '/api/dt/interview_history_delete/', data)
  },
  getInterviewHistory(id) {
    return session.get(uri + '/api/dt/interview_history/' + id)
  },
  // 録画面接関連
  // RecordingInterview
  createRecordingInterview(data) {
    return session.post(uri + '/api/dt/recording_inteview/', data)
  },
  getRecordingInterview(id) {
    if (id) return session.get(uri + '/api/dt/recording_inteview/' + id)
    else return session.get(uri + '/api/dt/recording_inteview/')
  },
  getRecordingInterviewAny(id) {
    if (id) return session.get(uri + '/api/dt/recording_inteview_any/' + id)
  },
  updateRecordingInterview(data) {
    return session.patch(uri + '/api/dt/recording_detail/' + data.id, data)
  },
  deleteRecordingInterview(id) {
    return session.delete(uri + '/api/dt/recording_inteview/' + id)
  },
  // RecordingContent
  createRecordingContent(data) {
    return session.post(uri + '/api/dt/recording_content/', data)
  },
  getRecordingContent(id) {
    if (id) return session.get(uri + '/api/dt/recording_content/' + id)
    else return session.get(uri + '/api/dt/recording_content/')
  },
  updateRecordingContent(data) {
    return session.patch(uri + '/api/dt/recording_content/' + data.get('id'), data)
  },
  deleteRecordingContent(id) {
    return session.delete(uri + '/api/dt/recording_content/' + id)
  },
  // RecordingAnswer
  createRecordingAnswer(data) {
    return session.post(uri + '/api/dt/recording_answer/', data)
  },
  updateRecordingAnswer(data) {
    return session.patch(uri + '/api/dt/recording_answer/', data)
  },
  updateRecordingReadAnswer(data) {
    return session.post(uri + '/api/dt/recording_answer_read/', data)
  },
  updateRecordingSelectSeeker(data) {
    return session.post(uri + '/api/dt/recording_select_seeker/', data)
  },
  getRecordingAnswerSeeker(id) {
    return session.get(uri + '/api/dt/get_recording_answer_seeker/' + id + '/')
  },
  getRecordingAnswer({ id, id2 }) {
    return session.get(uri + '/api/dt/get_recording_answer/' + id + '/' + id2)
  },
  getRecordingDetail(id) {
    return session.get(uri + '/api/dt/recording_detail/' + id)
  },
  // Eメール送付（録画面接後）
  completeRecordingAnswerNotify(data) {
    return session.post(uri + '/api/dt/complete_recording_answer_notify/', data)
  },
  createCompleteRecordingAnswerInfo(data) {
    return session.post(uri + '/api/dt/create_complete_recording_answer_info/', data)
  },
  updateCompleteRecordingAnswerInfo(data) {
    return session.patch(uri + '/api/dt/update_complete_recording_answer_info/' + data.id, data)
  },
  interviewedUserDuplicateCheck(data) {
    return session.post(uri + '/api/dt/interviewed_user_duplicate_check/', data)
  },
  getAutoFlow() {
    return session.get(uri + '/api/dt/auto_flow/')
  },
  createAutoFlow(data) {
    return session.post(uri + '/api/dt/auto_flow/', data)
  },
  deleteAutoFlow(id) {
    return session.delete(uri + '/api/dt/auto_flow/' + id)
  },
  setAutoAction(bot_id) {
    return session.post(uri + '/api/dt/set_auto_action/', bot_id)
  },
  bulkUpdateSeekerManage(data) {
    return session.patch(uri + '/api/dt/bulk_update_seeker_manage/', data)
  },
  getSeekerDetailManage(data) {
    return session.post(uri + '/api/dt/seeker_detail_manage/', data)
  },
  getSubscribeChangeHistory(seeker_id) {
    return session.get(uri + '/api/dt/subscribe_change_history/' + seeker_id)
  },
  getSeekerOne({ id, uid, isDuplicateSeekerFlag, isGetRoboTalk}) {
    return session.get(uri + '/api/dt/seeker_get_one/' + id + '/' + uid + '/' + isDuplicateSeekerFlag + '/' + isGetRoboTalk)
  },
  getRoboArgumentsData(argumentsParam) {
    return session.get(uri + '/api/dt/get_robo_arguments_data/' + argumentsParam.company_id + '/' + argumentsParam.robo_id + '/' + argumentsParam.seeker_id)
  },
  // 詳細シート内容
  getDetailSheetContents(seeker_id, template_id) {
    return session.get(uri + '/api/dt/detail_sheet_content_list?seeker='+seeker_id+'&template='+template_id)
  },
  updateDetailSheetContents(data) {
    return session.post(uri + '/api/dt/detail_sheet_content_list', data)
  },
  outputDetailSheet(data) {
    return stream.post(uri + '/api/dt/detail_sheet_output_pdf/', data)
  },
  // 採用フロー停止設定
  getPauseFlow() {
    return session.get(uri + '/api/dt/pause_flow/')
  },
  createPauseFlow(data) {
    return session.post(uri + '/api/dt/pause_flow/', data)
  },
  deletePauseFlow(id) {
    return session.delete(uri + '/api/dt/pause_flow/' + id)
  },
  // 応募者ブラックリスト
  getApplicantBlacklist() {
    return session.get(uri + '/api/dt/applicant_blacklist/')
  },
  createApplicantBlacklist(data) {
    return session.post(uri + '/api/dt/applicant_blacklist/', data)
  },
  deleteApplicantBlacklist(id) {
    return session.delete(uri + '/api/dt/applicant_blacklist/' + id)
  },
  // 応募者解析レポート用（媒体×年月日）
  aggregateSeekers(data) {
    return session.post(uri + '/api/dt/aggregate_seekers/', data)
  },
  // カスタムカラムの取得
  companyReportColumns(data) {
    return session.get(uri + '/api/dt/company_report_columns/', { params: data });
  },
  updateCompanyReportColumns(data) {
    return session.put(uri + '/api/dt/company_report_columns/', data);
  },
    // メッセージ解析データ 
  aggregatedMessages(data) {
  return session.post(uri + '/api/dt/aggregated_messages/', data)  
  },
  // サマリーテーブルの更新
  updateSeekerSummaryTable2(seekerSummaryTable2Data) {
    return session.put(uri + '/api/dt/seeker_summary_table2/', seekerSummaryTable2Data);
  },
  // レポートの絞り込み用に選ばれた選択肢を表示させる
  fetchFilterOptions() {
    return session.get(uri + '/api/dt/filter_options/');
  },
  // レポートで、その会社の応募者の年月の最大値と最小値を取ってくる
  fetchYearMonthRange(data) {
    return session.get(uri + '/api/dt/year_month_range/',  { params: data });
  },
  // サマリーテーブルを集計・表示させる
  fetchSeekerSummary(data) {
    return session.post(uri + '/api/dt/seeker_summary/', data);
  },
}



// WEBPACK FOOTER //
// ./src/api/directtalk.js